import React from 'react';
import './ShareRule.css';

/**
 * Share links for a specific Guy Rule: Facebook, X (Twitter), LinkedIn, WhatsApp.
 * Pass the rule URL and share text so the shared link and message are specific to that rule.
 */
function ShareRule({ url, title, ruleNumber }) {
  const shareUrl = url || (typeof window !== 'undefined' ? window.location.href : '');
  const shareTitle = title
    ? (ruleNumber != null ? `Guy Rule #${ruleNumber}: ${title} | GuyRules` : `${title} | GuyRules`)
    : 'GuyRules';
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedText = encodeURIComponent(shareTitle);

  const links = [
    {
      name: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      icon: 'bi bi-facebook',
      color: '#1877f2',
    },
    {
      name: 'X (Twitter)',
      href: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedText}`,
      icon: 'bi bi-twitter-x',
      color: '#000000',
    },
    {
      name: 'LinkedIn',
      href: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
      icon: 'bi bi-linkedin',
      color: '#0a66c2',
    },
    {
      name: 'WhatsApp',
      href: `https://wa.me/?text=${encodedText}%20${encodedUrl}`,
      icon: 'bi bi-whatsapp',
      color: '#25d366',
    },
  ];

  return (
    <section className="share-rule" aria-label="Share this rule">
      <span className="share-rule-label">Share:</span>
      <div className="share-rule-links">
        {links.map(({ name, href, icon, color }) => (
          <a
            key={name}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            className="share-rule-link"
            style={{ '--share-color': color }}
            aria-label={`Share on ${name}`}
            title={`Share on ${name}`}
          >
            <i className={icon} aria-hidden="true" />
          </a>
        ))}
      </div>
    </section>
  );
}

export default ShareRule;
